 import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import TrackOrder from './TrackOrder';
import { orderManagementQuery } from '../../Query/orderManagementQuery';
import { useTranslation } from 'react-i18next';

const OrderViewPage: React.FC = () => {
  const { t } = useTranslation();
  const { orderId } = useParams<{ orderId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const trackingOrder = location.state?.trackingOrder;

  // If trackingOrder is passed via state, use it directly
  if (trackingOrder) {
    return (
      <Box p={2}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          sx={{ mb: 2 }}
          variant="outlined"
        >
          {t('orderManagement.orderView.back')}
        </Button>
        <TrackOrder trackingOrder={trackingOrder} />
      </Box>
    );
  }

  // Otherwise, fetch by orderId
  const { data, isLoading } = orderManagementQuery({ search: orderId });

  if (isLoading) {
    return (
      <Box p={2}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          sx={{ mb: 2 }}
          variant="outlined"
        >
          {t('orderManagement.orderView.back')}
        </Button>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  if (!data?.orders || data.orders.length === 0) {
    return (
      <Box p={2}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          sx={{ mb: 2 }}
          variant="outlined"
        >
          {t('orderManagement.orderView.back')}
        </Button>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <Typography color='error'>{t('orderManagement.messages.orderNotFound')}</Typography>
        </Box>
      </Box>
    );
  }

  // Assuming the API returns an array of orders, pick the first one
  const order = data.orders[0];

  return (
    <Box p={2}>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(-1)}
        sx={{ mb: 2 }}
        variant="outlined"
      >
        Back
      </Button>
      <TrackOrder trackingOrder={order} />
    </Box>
  );
};

export default OrderViewPage; 